import { RouteRecordRaw } from 'vue-router'

export const cockpitRoutes: RouteRecordRaw[] = [
  {
    path: '/time-de-saude',
    name: 'cockpit-time-de-saude',
    component: () =>
      /* webpackChunkName: "HCockpit" */
      import('@/components/cockpit/organisms/HCockpit.vue'),
    meta: {
      onlyLoggedIn: true,
      title: 'EHR - Início'
    }
  },
  {
    path: '/especialista',
    name: 'cockpit-especialista',
    component: () =>
      import(
        /* webpackChunkName: "HCockpit" */
        '@/components/cockpit/organisms/HSpecialistCockpit.vue'
      ),
    meta: {
      onlyLoggedIn: true,
      title: 'EHR - Início'
    }
  }
]
